<template>
  <div class="wb-sidebar-categories-label">
      <div class="wb-sidebar-categories-label-text">{{text}}</div>
  </div>
</template>

<script>
export default {
    name: 'SidebarMenuLabel',
    props: [
        'text',
    ],
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/common.scss";

.wb-sidebar-categories-label {
    width: 100%;
    box-sizing: border-box;
    cursor: default;
    user-select: none;
    @include font-hcl;
}

.wb-sidebar-categories-label-text {
    color: $green2;
    padding: 5px 0;
    text-align: center;
    @include wb-c-flex-center-start;
}
</style>
